import { sh } from '@tpluscode/rdf-ns-builders';
import ConstraintComponent, { assertTerm } from './ConstraintComponent.js';
export class PropertyConstraintComponent extends ConstraintComponent {
    constructor(shape) {
        super(sh.PropertyConstraintComponent);
        this.shape = shape;
    }
    static *fromShape(shape, factory) {
        const properties = shape.get(sh.property) || [];
        for (const property of properties) {
            assertTerm(property);
            yield new PropertyConstraintComponent(factory.propertyShape(property.pointer));
        }
    }
    buildPropertyShapePatterns(arg) {
        return this.shape.buildConstraints(arg);
    }
}
